import { render, staticRenderFns } from "./voice_recognition_form.vue?vue&type=template&id=7907dd64"
import script from "./voice_recognition_form.vue?vue&type=script&lang=js"
export * from "./voice_recognition_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports